import {Action, ActionType, Aws} from "../model";
import createReducer from "./createReducer";

interface State {
    [key: string]: any;
}

const initialState: State = {};

export const currentPage = createReducer<State>(initialState, {
    [ActionType.SET_PAGE_PROP](
        state:any,
        action: Action<{ key: string; value: any }>
    ) {
        const { key, value } = action.payload;
        return {
            ...state,
            [key]: value,
        };
    },

    [ActionType.CLEAR_PAGE](
        state:any,
        action: Action<{ keys?: string[] }>
    ) {
        if ( action.payload && action.payload.keys) {
            for (const key of action.payload.keys) {
                delete state[key];
            }
        } else {
            // Clear all keys
            Object.keys(state).forEach((key) => delete state[key]);
        }
        return { ...state };
    },
});
